import { Navigate, useSearchParams } from 'react-router-dom'
import { Button, Box } from '@mui/material'
import { PageHeader } from '@/shared/components/PageHeader'
import { useDocumentTitle } from '@/shared/hooks/useDocumentTitle'
import { resolveInstrumentListRedirect } from '../lib/instrumentNavigation'

export function InstrumentListPage() {
  useDocumentTitle('Instruments')
  const [searchParams] = useSearchParams()
  const redirectTo = resolveInstrumentListRedirect(searchParams)

  if (redirectTo) {
    return <Navigate to={redirectTo} replace />
  }

  return (
    <>
      <PageHeader
        title="Instruments"
        action={<Button variant="contained">New Instrument</Button>}
      />
      <Box>{/* DataGrid for instruments */}</Box>
    </>
  )
}
